import React, {useContext} from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import translate from '../../i18n/translate';
import { Link } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import HelpIcon from '@mui/icons-material/Help';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import HistoryIcon from '@mui/icons-material/History';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { KeycloackContext } from "../../services/keycloakProvider"

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function CustomizedMenus() {
  const { logout } = useContext(KeycloackContext)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        style={{backgroundColor: "#8EBF55", marginRight: "2rem"}}
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Menu
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Link to="/" style={{ textDecoration: 'none' }}>
            <MenuItem onClick={handleClose} disableRipple>
            <HomeIcon />
            {translate("navbar.accueil")}
            </MenuItem>
        </Link>
        <Divider sx={{ my: 0.5 }} />
        <Link to="/questionnaire" style={{ textDecoration: 'none' }}>
            <MenuItem onClick={handleClose} disableRipple>
            <PlayCircleFilledWhiteIcon />
            {translate("navbar.commencer")}
            </MenuItem>
        </Link>
        <Link to="/capsules" style={{ textDecoration: 'none' }}>
            <MenuItem onClick={handleClose} disableRipple>
            <VideoLibraryIcon />
            {translate("navbar.capsule")}
            </MenuItem>
        </Link>
        <Link to="/strategies" style={{ textDecoration: 'none' }}>
            <MenuItem onClick={handleClose} disableRipple>
            <HistoryIcon />
            {translate("navbar.strategie")}
            </MenuItem>
        </Link>
        <Divider sx={{ my: 0.5 }} />
        <Link to="/contact" style={{ textDecoration: 'none' }}>
            <MenuItem onClick={handleClose} disableRipple>
            <HelpIcon />
            {translate("navbar.contact")}
            </MenuItem>
        </Link>
        <Link to="/" style={{ textDecoration: 'none' }}>
        <MenuItem onClick={() => logout()} disableRipple>
          <ExitToAppIcon />
          {translate("navbar.deconnection")}
        </MenuItem>
        </Link>
      </StyledMenu>
    </div>
  );
}